import React from "react";
import SbEditable from "storyblok-react";
import Components from "../components";
import Section from "@/components/Section/section";
import LayoutGrid from "../Layout/layout-grid";
import CoachCard from "@/components/Coaches/coach-card";
import classnames from "classnames";
import Main from "@/components/Layout/main";
import SectionItem from "@/components/Section/section-item";
import styles from "./coach.module.scss";
import FormNewsletter from "@/components/FormNewsletter/form-newsletter";
import { CoachesPageStoryblok } from "@/types/component-types-sb";
import { GetCoaches } from "@/lib/storyblok-gapi";

interface Props {
  content: CoachesPageStoryblok;
  blok: CoachesPageStoryblok;
  coaches: GetCoaches;
}

const CoachesIndex = (props: Props) => {
  const {
    content: { body },
    coaches,
  } = props;
  const layoutVars = {
    ["--cols-m" as string]: 1,
    ["--cols-d" as string]: 3,
    ["--col-start" as string]: "main-start",
    ["--col-end" as string]: "main-end",
  };
  const gridClasses = classnames(styles.coachesGrid);

  return (
    // @ts-expect-error
    <SbEditable content={props.content}>
      <Main className="page-main">
        <Section {...props.blok} component="section">
          {body?.map((blok) => {
            return (
              <SectionItem key={blok._uid} {...blok} className={blok.component}>
                {React.createElement(Components(blok.component), {
                  blok,
                })}
              </SectionItem>
            );
          })}
          <LayoutGrid vars={layoutVars} className={gridClasses}>
            {coaches?.map((blok) => (
              <CoachCard key={blok._uid} {...blok} />
            ))}
          </LayoutGrid>
          <FormNewsletter />
        </Section>
      </Main>
    </SbEditable>
  );
};

export default CoachesIndex;
